import React, {Component} from "react";
import "../../VisitHistory.css";
import RelationshipEnum from "../../../subjective/enums/history/RelationshipEnum";

export default class FamilyViewHistory extends Component {
    render() {
        if (this.props.familyHistory == null) {
            return <div className="pl-3">No information available</div>;
        } else if (this.props.familyHistory.none) {
            return <div className="pl-3">No Family History</div>;
        }

        let familyHistory = this.getFamilyHistoryItems();

        return (
            <div className="pl-3">
                {familyHistory}
            </div>
        );
    }

    getFamilyHistoryItems() {
        if (this.props.familyHistory.items == null
            || this.props.familyHistory.items.length === 0) {
            return null;
        }

        let familyHistoryItems = [];

        this.props.familyHistory.items.forEach((item, index) => {
            familyHistoryItems.push(
                <div id={"familyViewHistoryDiv" + index}>
                    <b>{item.condition}</b>
                    {RelationshipEnum[item.relationship]? ": "+RelationshipEnum[item.relationship]?.name : ""}
                    {item.detail == null ? "" : (", " + item.detail)}
                </div>);
        });

        return familyHistoryItems;
    }
}